import {
  CalendarClock,
  CreditCard,
  LayoutGrid,
  QrCode,
  ScanLine,
  Users,
} from "lucide-react";
import { VENUE_FEATURES } from "../content/landing";
import { useT } from "../i18n";
import { cardClass, sectionHeading, sectionSubheading } from "../lib/ui";

const VENUE_ICONS = {
  orders: LayoutGrid,
  stripe: CreditCard,
  qr: QrCode,
  handover: ScanLine,
  team: Users,
  schedule: CalendarClock,
} as const;

export default function ForVenues() {
  const translate = useT();

  return (
    <section
      id="for-venues"
      className="border-y border-[var(--border-subtle)] bg-surface/40 py-16 sm:py-24"
      aria-labelledby="for-venues-heading"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <h2 id="for-venues-heading" className={sectionHeading}>
            {translate("forVenuesTitle")}
          </h2>
          <p className={sectionSubheading}>{translate("forVenuesSubtitle")}</p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {VENUE_FEATURES.map((feature) => {
            const Icon = VENUE_ICONS[feature.icon];
            return (
              <li key={feature.icon} className={`${cardClass} p-6`}>
                <div className="mb-4 inline-flex rounded-xl bg-brand-soft p-3">
                  <Icon className="h-6 w-6 text-accent" aria-hidden />
                </div>
                <h3 className="font-display text-lg font-semibold">{translate(feature.titleKey)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {translate(feature.bodyKey)}
                </p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
